import { CloudCode } from './cloudcode';

export interface GiftCard {
  id: string
  amount: number
  code: string
  hyphenatedCode: string
}

export interface PurchaseGiftCardParams {
  amount: number
  customerID: string
}

export class GiftCardsService {

  static purchaseGiftCard(
    params: PurchaseGiftCardParams,
    successCallback: (code: string) => void,
    errorCallback: (msg: string) => void) {

    CloudCode.run('purchaseGiftCard', 
      params,
      (code: string) => {
        successCallback(code);
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }

  static redeemGiftCard(
    code: string,
    successCallback: (giftCard: GiftCard) => void,
    errorCallback: (msg: string) => void) {

    let params = {
      code: code
    }

    CloudCode.run('redeemGiftCard', 
      params,
      (giftCard: GiftCard) => {
        successCallback(giftCard);
      }, 
      (msg: string) => {
        errorCallback(msg);
      });
  }
  
}